// src/components/mindworkout/sections/WorkoutFooter.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
    background: #1a1a1a;
    color: white;
    padding: 3rem 2rem 2rem;
`;

const ContentWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const FooterGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
`;

const FooterSection = styled.div``;

const FooterTitle = styled.h3`
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #FF6B6B;
`;

const FooterLink = styled(Link)`
    display: block;
    color: #ccc;
    text-decoration: none;
    padding: 0.25rem 0;
    transition: color 0.3s ease;
    
    &:hover {
        color: #FF6B6B;
    }
`;

const FooterBottom = styled.div`
    text-align: center;
    padding-top: 2rem;
    border-top: 1px solid #333;
    color: #999;
`;

const AppName = styled.span`
    font-weight: bold;
    color: #FF6B6B;
`;

const WorkoutFooter = () => {
    return (
        <FooterContainer>
            <ContentWrapper>
                <FooterGrid>
                    <FooterSection>
                        <FooterTitle>Mind Workout</FooterTitle>
                        <p style={{ color: '#ccc', lineHeight: 1.6 }}>
                            과학적으로 검증된 방법으로<br/>
                            당신의 정신력을 단련하세요
                        </p>
                    </FooterSection>

                    <FooterSection>
                        <FooterTitle>법적 고지</FooterTitle>
                        <FooterLink to="/workout/terms">이용약관</FooterLink>
                        <FooterLink to="/workout/privacy">개인정보처리방침</FooterLink>
                    </FooterSection>
                </FooterGrid>

                <FooterBottom>
                    <p>© 2025 <AppName>Mind Workout</AppName>. All rights reserved.</p>
                </FooterBottom>
            </ContentWrapper>
        </FooterContainer>
    );
};

export default WorkoutFooter;
